import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer
            className="bg-[hsl(var(--foreground))] text-[hsl(var(--background))] py-16 container-px"
            data-testid="site-footer"
        >
            <div className="grid sm:grid-cols-3 gap-10 items-start">
                <div>
                    <div className="font-serif text-3xl">López Hill</div>
                    <p className="mt-3 text-xs uppercase tracking-[0.3em] text-white/60">
                        Spicewood · Texas Hill Country
                    </p>
                </div>
                <div className="text-sm text-white/70 font-light leading-relaxed">
                    12649 TX-71<br />Spicewood, TX 78669<br />gallery@lopezhill.com
                </div>
                <div className="text-sm text-white/70 font-light flex flex-col gap-2">
                    <a href="#booking" className="hover:text-[hsl(var(--accent))] transition-colors">
                        Inquire about your date
                    </a>
                    <a href="#experience" className="hover:text-[hsl(var(--accent))] transition-colors">
                        The experience
                    </a>
                    <Link
                        to="/admin/login"
                        className="hover:text-[hsl(var(--accent))] transition-colors"
                        data-testid="footer-admin-link"
                    >
                        Team portal
                    </Link>
                </div>
            </div>

            <div className="mt-14 pt-6 border-t border-white/10 text-xs tracking-[0.2em] uppercase text-white/40 flex flex-wrap items-center justify-between gap-3">
                <span>© {new Date().getFullYear()} López Hill</span>
                <span>Crafted with intention</span>
            </div>
        </footer>
    );
}
